import meteringCrudFactory from "../meteringCrudFactory";
import type { MeteringLineItemsRequest, MeteringLineItemsResponse } from "@/features/metering/types";
import { logError, logEvent, logMeasurement } from "@/loggers";
import { FEATURE_NAMES, METRIC_TYPE } from "@/loggers/types";

const LINE_ITEMS_PATH = "line-items";
const api = meteringCrudFactory(LINE_ITEMS_PATH);

export const fetchMeteringLineItems = async (request: MeteringLineItemsRequest): Promise<MeteringLineItemsResponse> => {
  const apiStart = performance.now();
  try {
    return await api.createOne<MeteringLineItemsResponse>(request);
  } catch (err) {
    logEvent(FEATURE_NAMES.MVS_METERING, METRIC_TYPE.API_CALL_FAILURE, {
      api: LINE_ITEMS_PATH,
      statusCode: err?.response?.status,
      error: err instanceof Error ? err.message : String(err)
    });
    logError(
      FEATURE_NAMES.MVS_METERING,
      `Error fetching line items: ${err instanceof Error ? err.message : String(err)}`
    );
    throw err;
  } finally {
    logMeasurement(FEATURE_NAMES.MVS_METERING, METRIC_TYPE.API_CALL_LATENCY, performance.now() - apiStart, {
      api: LINE_ITEMS_PATH
    });
  }
};
